var map = {
	"./BaseModulo": [
		6267,
		[
			6267
		]
	],
	"./BaseModulo.js": [
		6267,
		[
			6267
		]
	],
	"./administracion/Dashboard": [
		8867,
		[
			5000,
			879,
			6150,
			323,
			5963,
			470,
			748,
			9382,
			7654,
			8867
		]
	],
	"./administracion/Dashboard.js": [
		8867,
		[
			5000,
			879,
			6150,
			323,
			5963,
			470,
			748,
			9382,
			7654,
			8867
		]
	],
	"./administracion/DashboardComercioBasic": [
		9963,
		[
			5000,
			879,
			6150,
			323,
			5963,
			470,
			748,
			9382,
			9963
		]
	],
	"./administracion/DashboardComercioBasic.js": [
		9963,
		[
			5000,
			879,
			6150,
			323,
			5963,
			470,
			748,
			9382,
			9963
		]
	],
	"./administracion/Data": [
		4532,
		[
			4532
		]
	],
	"./administracion/Data.js": [
		4532,
		[
			4532
		]
	],
	"./administracion/components/card-area-tendencia-ventas": [
		8411,
		[
			5000,
			6150,
			5963,
			8411
		]
	],
	"./administracion/components/card-area-tendencia-ventas.js": [
		8411,
		[
			5000,
			6150,
			5963,
			8411
		]
	],
	"./administracion/components/card-bar-clientes-recurrentes-vs-nuevos": [
		9825,
		[
			5000,
			879,
			6150,
			323,
			9825
		]
	],
	"./administracion/components/card-bar-clientes-recurrentes-vs-nuevos.js": [
		9825,
		[
			5000,
			879,
			6150,
			323,
			9825
		]
	],
	"./administracion/components/card-bar-disponibilidad-productos": [
		8525,
		[
			5000,
			879,
			6150,
			323,
			8525
		]
	],
	"./administracion/components/card-bar-disponibilidad-productos.js": [
		8525,
		[
			5000,
			879,
			6150,
			323,
			8525
		]
	],
	"./administracion/components/card-bar-rotacion-productos": [
		2259,
		[
			5000,
			879,
			6150,
			323,
			2259
		]
	],
	"./administracion/components/card-bar-rotacion-productos.js": [
		2259,
		[
			5000,
			879,
			6150,
			323,
			2259
		]
	],
	"./administracion/components/card-composed-ciclo-conversion-efectivo": [
		2010,
		[
			5000,
			879,
			6150,
			323,
			748,
			7422
		]
	],
	"./administracion/components/card-composed-ciclo-conversion-efectivo.js": [
		2010,
		[
			5000,
			879,
			6150,
			323,
			748,
			7422
		]
	],
	"./administracion/components/card-composed-kpi-resultados": [
		6268,
		[
			5000,
			879,
			6150,
			5963,
			748,
			3808
		]
	],
	"./administracion/components/card-composed-kpi-resultados.js": [
		6268,
		[
			5000,
			879,
			6150,
			5963,
			748,
			3808
		]
	],
	"./administracion/components/card-composed-tendencia-dolar": [
		1883,
		[
			5000,
			879,
			6150,
			5963,
			748,
			9382,
			7229
		]
	],
	"./administracion/components/card-composed-tendencia-dolar.js": [
		1883,
		[
			5000,
			879,
			6150,
			5963,
			748,
			9382,
			7229
		]
	],
	"./administracion/components/card-dona-distribucion-cobranzas": [
		7398,
		[
			5000,
			879,
			470,
			3400
		]
	],
	"./administracion/components/card-dona-distribucion-cobranzas.js": [
		7398,
		[
			5000,
			879,
			470,
			3400
		]
	],
	"./administracion/components/card-dona-distribucion-deuda": [
		7390,
		[
			5000,
			879,
			470,
			7648
		]
	],
	"./administracion/components/card-dona-distribucion-deuda.js": [
		7390,
		[
			5000,
			879,
			470,
			7648
		]
	],
	"./administracion/components/card-dona-distribucion-ingresos": [
		5883,
		[
			5000,
			879,
			470,
			1713
		]
	],
	"./administracion/components/card-dona-distribucion-ingresos.js": [
		5883,
		[
			5000,
			879,
			470,
			1713
		]
	],
	"./administracion/components/card-radar-variables.clave": [
		1189,
		[
			5000,
			7654,
			9938
		]
	],
	"./administracion/components/card-radar-variables.clave.js": [
		1189,
		[
			5000,
			7654,
			9938
		]
	],
	"./administracion/components/card-table-productos-baja-rotacion": [
		2651,
		[
			2651
		]
	],
	"./administracion/components/card-table-productos-baja-rotacion.js": [
		2651,
		[
			2651
		]
	],
	"./administracion/data-comercio-basic": [
		6861,
		[
			6861
		]
	],
	"./administracion/data-comercio-basic.js": [
		6861,
		[
			6861
		]
	],
	"./administracion/data-comercio-json": [
		3985,
		[
			3985
		]
	],
	"./administracion/data-comercio-json.js": [
		3985,
		[
			3985
		]
	],
	"./almacen/Inventario": [
		3475,
		[
			3475
		]
	],
	"./almacen/Inventario.js": [
		3475,
		[
			3475
		]
	],
	"./almacen/Movimiento": [
		9641,
		[
			9641
		]
	],
	"./almacen/Movimiento.js": [
		9641,
		[
			9641
		]
	],
	"./almacen/Producto": [
		835,
		[
			835
		]
	],
	"./almacen/Producto.js": [
		835,
		[
			835
		]
	],
	"./almacen/Recepcion": [
		5829,
		[
			5829
		]
	],
	"./almacen/Recepcion.js": [
		5829,
		[
			5829
		]
	],
	"./almacen/ResumenMovimientos": [
		9240,
		[
			9240
		]
	],
	"./almacen/ResumenMovimientos.js": [
		9240,
		[
			9240
		]
	],
	"./almacen/ResumenPedidos": [
		1539,
		[
			1539
		]
	],
	"./almacen/ResumenPedidos.js": [
		1539,
		[
			1539
		]
	],
	"./compras/Proveedores": [
		6917,
		[
			6917
		]
	],
	"./compras/Proveedores.js": [
		6917,
		[
			6917
		]
	],
	"./configuracion/Catalogo": [
		2449,
		[
			4830
		]
	],
	"./configuracion/Catalogo.js": [
		2449,
		[
			4830
		]
	],
	"./configuracion/Datacatalogo": [
		1427,
		[
			1427
		]
	],
	"./configuracion/Datacatalogo.js": [
		1427,
		[
			1427
		]
	],
	"./configuracion/Empresa": [
		9067,
		[
			9067
		]
	],
	"./configuracion/Empresa.js": [
		9067,
		[
			9067
		]
	],
	"./configuracion/Menu": [
		5451,
		[
			5451
		]
	],
	"./configuracion/Menu.js": [
		5451,
		[
			5451
		]
	],
	"./configuracion/MenuAsignado": [
		9061,
		[
			9061
		]
	],
	"./configuracion/MenuAsignado.js": [
		9061,
		[
			9061
		]
	],
	"./configuracion/Persona": [
		6028,
		[
			6028
		]
	],
	"./configuracion/Persona.js": [
		6028,
		[
			6028
		]
	],
	"./configuracion/Usuario": [
		6316,
		[
			6316
		]
	],
	"./configuracion/Usuario.js": [
		6316,
		[
			6316
		]
	],
	"./finanzas/Caja": [
		2066,
		[
			2066
		]
	],
	"./finanzas/Caja.js": [
		2066,
		[
			2066
		]
	],
	"./finanzas/Pagos": [
		8633,
		[
			3787,
			8633
		]
	],
	"./finanzas/Pagos.js": [
		8633,
		[
			3787,
			8633
		]
	],
	"./finanzas/TipoCambio": [
		7512,
		[
			7512
		]
	],
	"./finanzas/TipoCambio.js": [
		7512,
		[
			7512
		]
	],
	"./ventas/Clientes": [
		2170,
		[
			2170
		]
	],
	"./ventas/Clientes.js": [
		2170,
		[
			2170
		]
	],
	"./ventas/Pedido": [
		1447,
		[
			3787,
			1447
		]
	],
	"./ventas/Pedido.js": [
		1447,
		[
			3787,
			1447
		]
	],
	"./ventas/PedidosPagos": [
		86,
		[
			3787,
			86
		]
	],
	"./ventas/PedidosPagos.js": [
		86,
		[
			3787,
			86
		]
	],
	"./ventas/PedidosReportes": [
		4652,
		[
			4652
		]
	],
	"./ventas/PedidosReportes.js": [
		4652,
		[
			4652
		]
	],
	"./ventas/VentasCliente": [
		929,
		[
			929
		]
	],
	"./ventas/VentasCliente.js": [
		929,
		[
			929
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6682;
module.exports = webpackAsyncContext;